// extracted by mini-css-extract-plugin
export default {"wrapper":"Roleformheader_wrapper__R2OhF","createtxt":"Roleformheader_createtxt__JNUZW"};